'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const AnnouncementFactory = require('feedback/domain/factory/announcement/index');
const AnnouncementAPI = require('feedback/infra/api/announcement');
const AnnouncementAdminAPI = require('feedback/infra/api/admin/announcement');

class Repository {
    constructor() {
        _.extend(this, Backbone.Events);

        this._announcements = new Backbone.Collection();
    }

    getAnnouncement(announcementID) {
        return this._announcements.get(announcementID);
    }

    fetchAnnouncement(announcementID) {
        return new Promise((resolve, reject) => {
            let announcement = this.getAnnouncement(announcementID);
            if(announcement) {
                resolve(announcement);
                return;
            }

            return AnnouncementAPI.fetchByID(announcementID)
                .then(announcementJSON => {
                    const factory = new AnnouncementFactory();
                    return factory.build(announcementJSON);
                })
                .then(announcement => {
                    this.add(announcement);
                    resolve(announcement);
                }, reject);
        })
    }

    fetch(limit, cursor=null) {
        let pagination;

        return AnnouncementAdminAPI.fetchAll(limit, cursor)
            .then(data => {
                const factory = new AnnouncementFactory();
                const announcementsJSON = data.results;
                pagination = data.pagination || {};

                return Promise.all(
                    _.map(announcementsJSON, j => {
                        return factory.build(j);
                    })
                );
            })
            .then(announcements => {
                announcements = this.add(announcements, {merge: true});

                return {
                    models: announcements,
                    pagination: pagination,
                }
            });
    }

    add(announcements) {
        if(!_.isArray(announcements)) {
            announcements = [announcements];
        }

        let addedAnnouncements = [];

        _.each(announcements, announcement => {
            const isNew = ! this._announcements.get(announcement.getID());
            announcement = this._announcements.add(announcement, {merge: true});

            if(isNew) {
                this.trigger('add', announcement);
            } else {
                this.trigger('update', announcement);
            }

            addedAnnouncements.push(announcement);
        });

        return addedAnnouncements;
    }
}

module.exports = new Repository();



// WEBPACK FOOTER //
// ./feedback/domain/repository/announcement-admin.js